var _style, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgObservation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 55",
    style: {
      enableBackground: "new 0 0 55 55"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.7;}\n\t.st1{fill:#1EB65B;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 27.5,
    cy: 27.5,
    r: 26.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.5,3.2c13.4,0,24.3,10.9,24.3,24.3S40.9,51.8,27.5,51.8S3.2,40.9,3.2,27.5S14.1,3.2,27.5,3.2 M27.5,1.2 C13,1.2,1.2,13,1.2,27.5S13,53.8,27.5,53.8S53.8,42,53.8,27.5S42,1.2,27.5,1.2L27.5,1.2z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M42.1,28.1L42.1,28.1l-2.9-5.6c-0.5-0.9-1.4-1.6-2.3-1.9c-0.9-2.2-3.5-3.2-5.7-2.3c-1,0.5-1.9,1.3-2.3,2.3 c-0.8-0.4-1.8-0.4-2.7,0c-0.9-2.2-3.4-3.3-5.6-2.4c-1.1,0.4-1.9,1.3-2.4,2.4c-0.9,0.4-1.7,1-2.2,1.9l-2.4,4.3 c-2.1,3-1.3,7.2,1.8,9.2c3.1,2.1,7.3,1.2,9.3-1.8c0.6-0.9,1-2,1.1-3.1c0-0.2,0-0.4,0-0.6c0-0.5,0-0.9-0.1-1.3 c-0.1-0.3-0.1-0.5-0.2-0.8c0.5-1.1,1.8-1.5,2.9-1c0.4,0.2,0.8,0.6,1,1c-0.1,0.3-0.2,0.5-0.2,0.8c-0.1,0.4-0.1,0.9-0.1,1.3 c0,0.2,0,0.4,0,0.6c0.4,3.7,3.7,6.4,7.3,6.1c3.7-0.3,6.4-3.6,6.1-7.2C42.4,29.3,42.3,28.7,42.1,28.1z M19.2,34.9 c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.4,4.5-4.4c2,0,3.7,1.3,4.3,3.2c0.1,0.4,0.2,0.9,0.2,1.3C23.7,32.9,21.7,34.9,19.2,34.9z M35.8,34.9 c-2.5,0-4.5-2-4.5-4.5c0-0.4,0.1-0.9,0.2-1.3c0.6-1.9,2.3-3.2,4.3-3.2c1.2,0,2.4,0.5,3.3,1.4h0l0.2,0.3c1.6,1.9,1.2,4.7-0.7,6.3 C37.8,34.6,36.9,34.9,35.8,34.9z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgObservation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/observation.ef69451e202452e1372330bc2c6fdf19.svg";